import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import { stats, principles, milestones, awards, leadership, offices } from '../data/site';

const About = () => {
  return (
    <div className="about-page page-shell">
      <section className="about-hero section-dark">
        <span className="aurora-orb hero-orb-a" />
        <span className="aurora-orb hero-orb-b" />
        <div className="site-container-wide">
          <span className="section-eyebrow">About Dalytix</span>
          <h1>
            We turn data ambition into <span className="gradient-text serif-accent">production reality.</span>
          </h1>
          <p>
            Dalytix is a focused, senior AI and data consultancy. We design, build and operate
            the data platforms, governance controls, and AI systems modern businesses depend on.
          </p>
          <div className="hero-actions" style={{ marginTop: 28 }}>
            <Link to="/leadership" className="btn-light btn-arrow">Meet leadership</Link>
            <Link to="/case-studies" className="btn-ghost btn-arrow">Outcomes &amp; case studies</Link>
          </div>
        </div>
      </section>

      <section className="section-tight about-stats">
        <div className="site-container-wide">
          <div className="about-stats-grid">
            {stats.global.map((stat) => (
              <div className="stat-box professional-card" key={stat.label}>
                <strong>{stat.value}</strong>
                <span>{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section about-story">
        <div className="site-container-wide about-story-grid">
          <div>
            <span className="section-eyebrow">Our Story</span>
            <h2 className="section-title">A consultancy built by practitioners, for practitioners.</h2>
          </div>
          <div className="about-story-text">
            <p>
              Dalytix was founded in London in 2025 by senior practitioners who had spent careers
              inside Fortune 500 data teams and frontier AI groups — and who wanted to build a different
              kind of consultancy. One built around senior engineers, real production work, and
              deliverables that compile.
            </p>
            <p>
              Our work spans financial services, healthcare, retail, manufacturing, energy, insurance
              and SaaS. Every senior practitioner in a proposal is expected to stay close to delivery.
              Every engagement is anchored to a measurable outcome and a clean handover.
            </p>
            <p>
              We are deliberately small, deliberately senior, and deliberately focused on the work that
              matters — production AI, data platforms, MLOps, analytics, governance and cloud — for
              the few clients we accept each quarter.
            </p>
          </div>
        </div>
      </section>

      <section className="section principles-section section-dark">
        <div className="site-container-wide">
          <span className="section-eyebrow">Operating Principles</span>
          <h2 className="section-title">Six principles we hire, fire and ship by.</h2>
          <div className="principles-grid-about">
            {principles.map((p) => (
              <article className="principle-card glass-card" key={p.title}>
                <h3>{p.title}</h3>
                <p>{p.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section timeline-section">
        <div className="site-container-wide">
          <span className="section-eyebrow">Milestones</span>
          <h2 className="section-title">A focused first year. Compounding.</h2>
          <div className="timeline">
            {milestones.map((m) => (
              <div className="timeline-row" key={m.year}>
                <span className="timeline-year">{m.year}</span>
                <div className="timeline-line"><span /></div>
                <p>{m.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section awards-section section-dark">
        <div className="site-container-wide">
          <span className="section-eyebrow">Recognition</span>
          <h2 className="section-title">Year-one recognition from the platforms we work with.</h2>
          <ul className="awards-list-about">
            {awards.map((a) => (
              <li key={a}>
                <img src="/images/award-badge.svg" alt="" />
                <span>{a}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="section leadership-preview">
        <div className="site-container-wide">
          <div className="section-head-row">
            <div>
              <span className="section-eyebrow">Leadership</span>
              <h2 className="section-title">Senior practitioners. Active operators.</h2>
            </div>
            <Link to="/leadership" className="btn-outline btn-arrow">Meet the full team</Link>
          </div>
          <div className="leader-grid">
            {leadership.slice(0, 4).map((leader) => (
              <article className="leader-card professional-card" key={leader.name}>
                <img src={leader.avatar} alt={leader.name} />
                <h3>{leader.name}</h3>
                <span>{leader.role}</span>
                <p>{leader.short}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section offices-section section-dark">
        <div className="site-container-wide">
          <span className="section-eyebrow">Global Footprint</span>
          <h2 className="section-title">Three delivery hubs. One delivery model.</h2>
          <div className="offices-grid">
            {offices.map((o) => (
              <article className="office-card glass-card" key={o.city}>
                <img src={o.image} alt={o.city} />
                <div className="office-body">
                  <strong>{o.city}, {o.country}</strong>
                  <span>{o.region}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="site-container-wide professional-card">
          <h2>Looking for a serious AI &amp; data partner?</h2>
          <p>Bring us your business goal, platform challenge or AI idea. We will help define the path forward.</p>
          <div className="hero-actions">
            <Link to="/contact" className="btn-primary-large">Contact Dalytix</Link>
            <Link to="/request-demo" className="btn-outline btn-arrow">Book a consultation</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
